import type { PropsWithChildren } from "react";
import React from "react";

interface Props {
  className: string;
}

export const HideScroll = ({ className, children }: PropsWithChildren<Props>): JSX.Element => {
  return (
    <div className={`${className} overflow-y-hidden`}>
      <div className="scroll-px-5 overflow-x-scroll pb-4">{children}</div>
    </div>
  );
};
